import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import trash from "../assets/trash.svg";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { helpPagesData } from "../utils/helper";
import Help from "../components/Help";
import { deletePage, fetchList } from "../action/page";
import moment from "moment";
import { Spinner } from "react-bootstrap";
import Paginate from "../components/pagination";
import DeleteModal from "../components/DeleteModal";
import { toast } from "react-toastify";
import EmptyState from "../components/EmptyState";
import DeployTrigger from "../components/DeployTrigger";
import { useToast } from "../components/ToastProvider";

const Pages = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const { showToast } = useToast();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pageId, setPageId] = useState();

  const fetchPageList = async () => {
    setLoader(true);
    try {
      const result = await fetchList(pagination.page, pagination.limit);
      if (result?.status) {
        setPagination((prev) => ({
          ...prev,
          total: Math.ceil(result.data.total / prev.limit) || 0,
        }));
        setData(result?.data?.list);
        setLoader(false);
      }
    } catch (error) {
      setData([]);
      setLoader(false);
    }
  };

  const handlePageChange = (page) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("page", page);
    newParams.set("limit", pagination.limit);

    navigate(`?${newParams.toString()}`, { replace: true });

    setPagination((prev) => ({ ...prev, page: page }));
  };

  const handlePageSizeChange = (limit) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("page", 1);
    newParams.set("limit", limit);

    navigate(`?${newParams.toString()}`, { replace: true });

    setPagination((prev) => ({ ...prev, limit: limit, page: 1 }));
  };

  const confirmDelete = async () => {
    try {
      const res = await deletePage(pageId);
      if (res?.status) {
        setData((prev) => prev.filter((item) => item._id !== pageId));
        showToast(res?.message , "success");
      }
    } catch (error) {
      showToast("Failed to delete page", "error");
    }
    setShowDeleteModal(false);
  };

  useEffect(() => {
    fetchPageList();
  }, [params]);

  return (
    <>
      <PageHeader pageTitle="Pages">
          {data?.length > 0 && (
            <>
         
              <Help
                title={helpPagesData.pages.title}
                message={helpPagesData.pages.message}
                items={helpPagesData.pages.items}
              />
              <NavLink to="/pages/add-new" className="btn-black">
                Add New Page
              </NavLink>
            </>
          )}
      </PageHeader>
      {loader ? (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <Spinner size="md" />
        </div>
      ) : data?.length === 0 ? (
        <EmptyState />
      ) : (
        <div className="page-container">
          <div className="theme-card p-4">
            <div className="d-flex align-items-center mb-3">
              <div className="card-title pb-3">Overview</div>
              {/* <div className="sel-box ms-auto">
                <select name="selmenu" id="selmenu" className="theme-select">
                  <option value="">Filter</option>
                  <option value="">Filter Options</option>
                </select>
              </div> */}
            </div>
            <div className="table-responsive">
              <table className="pages-table">
                <thead>
                  <tr>
                    <th>Page Title</th>
                    <th>Slug</th>
                    <th>Status</th>
                    <th>Last Updated</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((page, i) => (
                    <tr
                      key={i}
                      onClick={() => navigate(`/pages/${page._id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{page.title}</td>
                      <td className="slug">{page.slug}</td>
                      <td>
                        <span className={`status ${page.status === "published" ? "success" : "warning"}`}>
                          {page.status === "published" ? "published" : "draft"}
                        </span>

                      </td>
                      {/* <td>
                      {page.visits}{" "}
                      <span className="visits-down">↓ {page.change}%</span>
                    </td> */}
                      <td>
                        {moment(page.updatedAt).format(
                          "DD/MM/YYYY"
                        )}
                      </td>
                      <td>
                        <button
                          className="delete-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            setPageId(page._id);
                            setShowDeleteModal(true);
                          }}
                        >
                          <img src={trash} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pt-3">
                {Boolean(pagination?.total) && (
                  <Paginate
                    currentPage={pagination?.page}
                    totalPages={pagination?.total}
                    onPageChange={handlePageChange}
                    pageSize={pagination.limit}
                    onPageSizeChange={handlePageSizeChange}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={confirmDelete}
      />
    </>
  );
};

export default Pages;
